import styled from 'styled-components'
import Select from 'react-select'

export const SelectInput = styled(Select)``
